(function (angular) {
    angular
        .module('app.purchase')
        .controller('app.purchase.PaymentInfoController', [
            'states',
            '$sce',
            '$scope',
            '$rootScope',
            'purchase',
            'app.purchase.purchaseFlowService',
            'ui',
            '$state',
            'paymentTypes',
            'app.paymentService',
            '$sessionStorage',
            'vcRecaptchaService',
            'supportService',
            '$uibModal',
            '$http',
            controller
            
        ]);

    function controller(
        states,
        $sce,
        $scope,
        $rootScope,
        purchase,
        purchaseFlowService,
        ui,
        $state,
        paymentTypesConstant,
        paymentService,
        $sessionStorage,
        vcRecaptchaService,
        supportService,
        $uibModal,
        $http
    ) {
        var vm = this;
        $sessionStorage['payment'] = null;

        vm.purchase = purchase;
        vm.siteContent = siteContent;

        vm.next = goToNext;
        vm.isBillingAddressSame = true;
        vm.billingAddressToggle = billingAddressToggle;
        vm.skipEnabled = skipEnabled;
        vm.paymentInfoFilled = paymentInfoFilled;
        vm.skip = skip;
        vm.publicCaptchaKey = environment.publicCaptchaKey;
        vm.captchaResponse;

        // Activation
        vm.billingAddressInfo = vm.purchase.billingAddress;
        vm.activate = activate;
        vm.paymentMethodLogo = '';
        vm.triggerPrivacyPolicyModal = showPrivacyPolicyModal;
        vm.OpenMembershipAgreementModal = OpenMembershipAgreementModal;
        vm.membershipAgreementChange = membershipAgreementChange;
        vm.showTermsOfUseModal = showTermsOfUseModal;
        vm.pdfFiles = { eula: '', servAndDis: '' };
        vm.treatmentApiUrl = environment.treatmentApiDirectUrl;
        vm.person = purchase.primaryApplicant;
        vm.hasPaymentMethod = vm.purchase.paymentAccount != null;
        vm.membershipAgreement = false;
        vm.communicationAgreement = true;
        vm.userState = '';
        vm.blobStorageUrl = environment.blobStorageTopUrl;
        vm.urlSafe = 'https://wellfitqa.blob.core.windows.net/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit.pdf'
        vm.memberAgreementUrl = environment.blobStorageTopUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Wellfit_2024.pdf';
        vm.cardNumberMasked = '0000';
        vm.state = '';
        vm.states = supportService.getStates();

        if ($rootScope.supportedStates.length <= 1) {
            // If plan has only one supported state or the purchased state is not supported, return the name of the default state
            vm.state = vm.states.filter(function (s) {
                return $rootScope.supportedStates.indexOf(s.abbr) >= 0;
            })[0].value;
        } else if ($rootScope.supportedStates.indexOf(vm.purchase.primaryApplicant.state) < 0) {
            vm.state = 'None';
        } else {
            // If purchased state is supported, return the name of the purchased state
            vm.state = vm.states.filter(function (s) {
                return vm.purchase.primaryApplicant.state.indexOf(s.abbr) >= 0;
            })[0].value;
        }

        // Auto Renewal
        // Determines if the plan offers auto renewal.
        vm.isAutoRenew = false;
        // Determines if the auto renewal is required to be clicked to continue.
        vm.isAutoRenewRequired = false;
        // Auto Renewal text.
        vm.autoRenewalText = null;
        // Determines if the current plan will be using auto renewal or not.
        vm.isPlanAutoRenew = false;
        // The auto renewal promo code description text
        vm.autoRenewalPromoCodeText = null;
        //is Medi-cal Insurance confirmed
        vm.isMedicalConfirmed = false;
        vm.isMedicalRequired = false;
        vm.showAutoRenewalDisclaimer = false;
        vm.showCardNumber = false;
        vm.showCvv = false;
        
        onInit();

        $scope.$on('priceChanged', function (event, purchase) {            
            vm.purchase.total = purchase.total;
        });
        
        $scope.showCardNumber = function(){
            vm.showCardNumber = !vm.showCardNumber;
        }

        $scope.showHideCvv = function(){
            vm.showCvv = !vm.showCvv;
        }

        function maskCard(input){
            if(typeof input !== undefined){
                var nums = input.toString().replace(/[^\d]/gi,"");
                var r = nums.match(/(\d){4}/g);
                for(var i=0;i<r.length-1;i++){
                    r[i] = r[i].replace(/[0-9]/g, "*");
                }
                r = r.slice(0,5);
                if(r){
                    var nStr = "", nums;
                    for (var i=0;i<r.length;i++){
                        nStr += i != r.length-1 ? r[i] + ((i<3)?" ":"") : r[i];
                    }
                    nums = (nums.length % 4 !== 0 ? nStr + " " + nums.substr((r.length * 4),nums.length) : nStr);
                    input = nums;
                } else {
                    input = nums;
                }
                return input;
            }
        }

        function billingAddressToggle() {
            vm.isBillingAddressSame = !vm.isBillingAddressSame;

            // Reset the fields
            vm.billingAddressInfo = {
                'address': '',
                'city': '',
                'state': '',
                'zipCode': ''
            };
        }

        function membershipAgreementChange() {            
            if(vm.membershipAgreement == true) {
                OpenMembershipAgreementModal();
            }
        }
        function OpenMembershipAgreementModal() {            
            var isMobileDevice = navigator.userAgent.match(/iPad|iPhone|iPod/i) != null || screen.width <= 480;                   
            if(isMobileDevice) {
                vm.membershipAgreement = true;                
                window.open(vm.urlSafe,'_blank');
            }            
            else {
                $rootScope.personState = vm.person.state;           
                $uibModal
                    .open({
                        templateUrl:
                            '/app/site/purchase-flow/plan-summary/modals/membership-agreements/membership-agreements.html',
                        keyboard: true,
                        windowTopClass: 'patolus-modal-backdrop',
                        controller: 'app.purchase.membershipAgreementsController',
                        controllerAs: 'vm'
                    })
                    .result.then(function fulfilled(result) {                    
                        if (result === true) {
                            vm.membershipAgreement = true;
                        } else {
                            vm.membershipAgreement = false;
                        }
                    });
            }
            
        };

        function showPrivacyPolicyModal() {
            $uibModal.open({
                templateUrl:
                    vm.siteContent.site.purchaseFlow.activatePlan.privacyPolicyTemplate &&
                    vm.siteContent.site.purchaseFlow.activatePlan.privacyPolicyTemplate.path
                        ? vm.siteContent.site.purchaseFlow.activatePlan.privacyPolicyTemplate.path
                        : '/app/site/purchase-flow/activate-plan/modals/privacy-policy.modal.html',
                keyboard: true,
                windowTopClass: 'patolus-modal-backdrop',
                controller: 'app.purchase.privacyPolicyModalController',
                controllerAs: 'vm'                              
            });           
        }

        function showTermsOfUseModal() {
            $uibModal.open({
                templateUrl:
                    vm.siteContent.site.purchaseFlow.activatePlan.touLink &&
                    vm.siteContent.site.purchaseFlow.activatePlan.touLink.path
                        ? vm.siteContent.site.purchaseFlow.activatePlan.touLink.path
                        : '/app/site/purchase-flow/activate-plan/modals/terms-of-use.modal.html',
                keyboard: true,
                windowTopClass: 'patolus-modal-backdrop',
                controller: 'app.purchase.termsOfUseModalController',
                controllerAs: 'vm'
            });
        }

        function activate(cardInfo, checkInfo) {
            // ui.block();
            try {
                var noPayment = true;
                if ((cardInfo != null || checkInfo != null) && vm.purchase.total > 0) {
                    noPayment = false;
                    var lastFourDigits;
                    var isAutoRenew = vm.purchase.autoRenewalDetail.autoRenewalRequired;

                    if (cardInfo != null) {
                        lastFourDigits = vm.creditCardInfo.cardNumber.substring(
                            vm.creditCardInfo.cardNumber.length - 4
                        );
                        if (vm.paymentInfo && vm.paymentInfo.card) {
                            isAutoRenew = vm.paymentInfo.card.isAutoRenew;
                        }
                    } else if (checkInfo != null) {
                        lastFourDigits = vm.checkingAccountInfo;
                    }

                    complete(cardInfo, checkInfo, lastFourDigits, isAutoRenew);
                }

                if (noPayment) {
                    complete(null, null, null, false);
                }
            } catch (e) {
                ui.unblock();
                console.error(e);
            }
        }

        function complete(cardInfo, checkInfo, accountNumber, isAutoRenew) { 
            purchaseFlowService
                .completePurchase(cardInfo, checkInfo, accountNumber, isAutoRenew, !vm.communicationAgreement, vm.isMedicalConfirmed,vm.captchaResponse)
                .then(function (response) {                     
                    $sessionStorage['payment'] = null;
                    ui.unblock();
                    $state.go('app.purchase.activated', { promoCode: vm.purchase.promoCode });
                    appendDigitalData(response.transactionId, vm.purchase.promoCode);
                })
                .catch(function rejected(response) {
                    ui.unblock();
                    ui.handleError(response);
                });
        }

        /*
        The following data is pushed to the json object 
        located in the head of on the index.html page to
        be used as a data layer for tracking purposes
        */
        function appendDigitalData(transactionId, promoCode) {
            var newData = [
                {
                    'page': {
                        'pageInfo': {
                            'pageID': '/plans/activated'
                        }
                    },
                    'transaction': {
                        'id': transactionId
                    },
                    'attributes': {
                        'promoCode': promoCode
                    }
                }
            ];
            digitalData = Object.assign({}, newData);
        }

        function restartPurchase() {
            $uibModal.open({
                templateUrl: '/app/site/purchase-flow/restart-puchase/modals/restart-puchase.modal.html',
                keyboard: false,
                windowTopClass: 'patolus-modal-backdrop',
                controller: 'app.purchase.restartPurchaseModalController',
                controllerAs: 'vm'
            });
        }

        function save() {
            if (vm.purchase && vm.purchase.started && vm.purchase.started != null && vm.purchase.started != '') {
                var maxPurchaseTime = 30;
                try {
                    if (environment.maxPurchaseTime && parseInt(environment.maxPurchaseTime) > 0) {
                        maxPurchaseTime = parseInt(environment.maxPurchaseTime);
                    }
                }
                catch (error) {}

                var startedDate = new Date(vm.purchase.started);
                var diff = new Date().getTime() - startedDate.getTime(); 
                var minutes = (diff / 60000);
                if (minutes > maxPurchaseTime) {
                    restartPurchase();
                    return;
                }
            }


            /* Reflect the proper billing address:
             *  If same then replicate what's on user profile
             *  If not the same then no further action is needed; the respective billing info object had been updated already
             **/
            if (vm.isBillingAddressSame) {
                vm.billingAddressInfo.address = vm.person.address;
                vm.billingAddressInfo.city = vm.person.city;
                vm.billingAddressInfo.state = vm.person.state;
                vm.billingAddressInfo.zipCode = vm.person.zipCode;
            }

            var paymentInfoUpdate = {
                paymentType: vm.paymentType,
                isBillingAddressSame: vm.isBillingAddressSame,
                billingAddressInfo: vm.billingAddressInfo,
                creditCardInfo: null,
                checkingAccountInfo: null
            };

            if (creditCardFormFilled()) {
                ui.block();
                return paymentService
                    .tokenizePaymentMethod(vm.creditCardInfo.cardNumber, vm.creditCardInfo.securityCode)
                    .then(function (result) {
                        if (vm.isPlanAutoRenew) {
                            vm.creditCardInfo.isAutoRenew = vm.isAutoRenew;
                        }
                        $sessionStorage['payment'] = { card: vm.creditCardInfo, check: null };

                        var cardInfo = {
                            name: vm.creditCardInfo.firstName + ' ' + vm.creditCardInfo.lastName,
                            paymentType: result.type,
                            expirationDate: vm.creditCardInfo.expirationDate,
                            payPageRegistrationId: result.paypageRegistrationId,
                            lastFour: result.lastFour,
                            zipCode: vm.billingAddressInfo.zipCode
                        };

                        cardInfo.address = vm.billingAddressInfo.address;
                        cardInfo.city = vm.billingAddressInfo.city;
                        cardInfo.state = vm.billingAddressInfo.state;
                        cardInfo.zipCode = vm.billingAddressInfo.zipCode;
                        cardInfo.token = vm.captchaResponse;

                        activate(cardInfo, null);
                    })
                    .finally(function rejected(response) {
                        vcRecaptchaService.reload();
                    });
            } else if (checkingAccountFormFilled()) {
                paymentInfoUpdate.checkingAccountInfo = vm.checkingAccountInfo;
                ui.block();
                $sessionStorage['payment'] = { card: null, check: vm.checkingAccount };
                activate(null, paymentInfoUpdate.checkingAccountInfo);
            }
        }

        function skip() {
            if (this.skipEnabled()) {
                ui.block();
                purchaseFlowService
                    .removePaymentAccount()
                    .then(function () {
                        // $state.go('app.purchase.activation');
                        activate();
                    })
                    .catch(function rejected(response) {
                        ui.handleError(response);
                    })
                    .finally(function () {
                        ui.unblock();
                    });
            }
        }

        function goToNext() {
            $http.get(environment.statusUrl + 'online/status/' + environment.portalId).then(function (response) {
                if(response.status == 200) {
                    save();
                }
            });
            
        }

        function onInit() {
            // Constants
            vm.paymentTypes = paymentTypesConstant;
            vm.states = states;

            // Lookup existing data available
            vm.person = vm.purchase.responsibleParty;
            if (!vm.person || vm.person === null) {
                vm.person = vm.purchase.primaryApplicant;
            }
            
            vm.userState = vm.person.state;
            if (vm.userState == 'CA') {
                vm.memberAgreementUrl = vm.blobStorageUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_California_2024.pdf';
              } else if (vm.userState == 'WA') {
                vm.memberAgreementUrl = vm.blobStorageUrl + '/servicesanddisclosures/DOS_DF_Smile_Generation_Washington.pdf';    
              }
            vm.urlSafe = $sce.trustAsResourceUrl(vm.memberAgreementUrl);
            //set required medi cal insurance for CA            
            if(vm.userState == 'CA')
            { 
                purchaseFlowService.getFeatureFlags()
                .then(function (flags) {
                    if (flags[Features.ShowMedicalAcknowledge] === true) {
                        vm.isMedicalRequired = true;
                    }
                })
                .catch(function (error) {
                    console.error('Error loading feature flags:', error);
                });

            }

            purchaseFlowService.getFeatureFlags()
            .then(function (flags) {
                if (flags[Features.ShowAutoRenewalDisclaimer] === true && vm.userState != 'WA') {
                    vm.showAutoRenewalDisclaimer = true;
                }
            })
            .catch(function (error) {
                console.error('Error loading feature flags:', error);
            });            
            
            // Set Auto Renewal Defaults            
            if (vm.purchase.autoRenewalDetail) {
                if (vm.purchase.autoRenewalDetail.autoRenewalOffered) {
                    vm.isPlanAutoRenew = true;
                } else {
                    vm.isPlanAutoRenew = false;
                }
                if (vm.purchase.autoRenewalDetail.autoRenewalRequired) {
                    vm.isAutoRenewRequired = true;
                } else {
                    vm.isAutoRenewRequired = false;                                        
                }
                vm.autoRenewalText = vm.purchase.autoRenewalDetail.autoRenewalText;
                vm.autoRenewalPromoCodeText = vm.purchase.autoRenewalDetail.autoRenewalPromoCodeText;
            }

            vm.paymentInfo = vm.purchase.paymentInfo;

            // Set defaults
            if (vm.paymentInfo) {
                vm.paymentType = vm.paymentInfo.paymentType;
                vm.isBillingAddressSame = vm.paymentInfo.isBillingAddressSame;
                vm.creditCardInfo = vm.paymentInfo.creditCardInfo;
                vm.checkingAccountInfo = vm.paymentInfo.checkingAccountInfo;
                vm.billingAddressInfo = vm.paymentInfo.billingAddressInfo;
            } else {
                vm.paymentType = vm.paymentTypes.creditCard;

                vm.creditCardInfo = {
                    'cardNumber': '',
                    'expirationDate': '',
                    'securityCode': '',
                    'firstName': vm.person.firstName,
                    'lastName': vm.person.lastName
                };

                vm.checkingAccountInfo = {
                    'routingNumber': '',
                    'accountNumber': '',
                    'firstName': vm.person.firstName,
                    'lastName': vm.person.lastName
                };

                vm.billingAddressInfo = {
                    'address': '',
                    'city': '',
                    'state': '',
                    'zip': ''
                };
            }
        }

        function skipEnabled() {
            return vm.purchase.total === 0;
        }

        function creditCardFormFilled() {
            var creditCard = vm.creditCardInfo;
            
            // Using == intentionally to check null & undefined
            if (creditCard == null) {
                return false;
            }
            var cardNumber = creditCard.cardNumber != null && creditCard.cardNumber.length > 0;
            var expiration = creditCard.expirationDate != null && creditCard.expirationDate.length > 0;
            var firstName = creditCard.firstName != null && creditCard.firstName.length > 0;
            var lastName = creditCard.lastName != null && creditCard.lastName.length > 0;
            var securityCode = creditCard.securityCode != null && creditCard.securityCode.length > 0;
            return cardNumber && expiration && firstName && lastName && securityCode;
        }

        function checkingAccountFormFilled() {
            var checkingAccount = vm.checkingAccountInfo;

            if (checkingAccount == null) {
                return false;
            }

            var routingNumber = checkingAccount.routingNumber != null && checkingAccount.routingNumber.length > 0;
            var accountNumber = checkingAccount.accountNumber != null && checkingAccount.accountNumber.length > 0;
            var firstName = checkingAccount.firstName != null && checkingAccount.firstName.length > 0;
            var lastName = checkingAccount.lastName != null && checkingAccount.lastName.length > 0;

            return routingNumber && accountNumber && firstName && lastName;
        }

        function paymentInfoFilled() {
            return creditCardFormFilled() || checkingAccountFormFilled();
        }

        
    }
})(angular);
